module.exports = __webpack_public_path__ + "img/screen1.1cd824e1.png";